import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IGetUnavailableSlotsByTokenPayload } from '@app-store/slices/sharedLists/getUnavailableSlotsByToken'

interface TaskAction extends Action {
    payload: IGetUnavailableSlotsByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.getUnavailableSlotsByToken

function* getUnavailableSlotsByTokenTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/unavailable/by-token?token=${payload.token}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getUnavailableSlotsByToken(): any {
    yield takeLatest<TaskAction>(onRequest, getUnavailableSlotsByTokenTask)
}

export default getUnavailableSlotsByToken
